import type { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    // Brand
    colorPrimary: "#0081B3",

    // Typography
    fontFamily: "Inter",
    fontSize: 14,

    // Button
    borderRadiusLG: 16,
    controlHeightLG: 56,

    // Input
    colorBorder: "#CCC",
    colorText: "#272728",

    paddingXXS: 8,
  },
  components: {
    Input: {
      borderRadiusLG: 16,
      controlHeightLG: 56,
      fontSizeLG: 14,
      paddingInlineLG: 16,
      paddingBlockLG: 14,
    },
    Button: {
      contentFontSizeLG: 14,
      fontWeight: 700,
    },
    Form: {
      labelColor: "#666",
    },
    Select: {
      optionPadding: "8px 12px",
      fontSizeLG: 14,
      optionFontSize: 14,
      borderRadiusLG: 16,
      controlHeightLG: 56,
    },
    Menu: {
      itemPaddingInline: 32,
    },
  },
};
